
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbRelatorioAcionamentos extends AppService {
  abstract getRelatorioAberturaporta(filter: String): Observable<any>;
  abstract getRelatorio(filter: string): Observable<any>;
  abstract getPortas(): Observable<any>;

}